import * as THREE from 'three';
import { cameraPos1, cameraPos2, SCENE_OBJ_NAMES } from './constants';
import { sceneObjects } from './index';
import { gsap } from 'gsap';

export const cameraConfigs = {
  movement: {
    isAuto: true,
    isVertical: true,
    set: function (isAuto = true, isVertical = true) {
      this.isAuto = isAuto;
      this.isVertical = isVertical;
      if (!isAuto) {
        const camera = sceneObjects.get(SCENE_OBJ_NAMES.camera);
        cameraPositionAnimation(camera, isVertical ? cameraPos2 : cameraPos1);
      }
    },
  },
};

export const createCamera = () => {
  const canvas = document.getElementById('roulette-canvas');
  const aspectRatio = canvas.width / canvas.height;

  const camera = new THREE.PerspectiveCamera(50, aspectRatio, 0.1, 1000);
  camera.position.set(cameraPos1.position.x, cameraPos1.position.y, cameraPos1.position.z);
  camera.rotation.set(cameraPos1.rotation.x, cameraPos1.rotation.y, cameraPos1.rotation.z);
  return camera;
};

export const cameraPositionAnimation = (camera, { position, rotation }) => {
  gsap.to(camera?.position, {
    duration: 2,
    x: position.x,
    y: position.y,
    z: position.z,
  });

  gsap.to(camera?.rotation, {
    duration: 2,
    x: rotation.x,
    y: rotation.y,
    z: rotation.z,
  });
};

export const setCameraData = (camera, { position, rotation }) => {
  position && camera?.position.set(position.x, position.y, position.z);
  rotation && camera?.rotation.set(rotation.x, rotation.y, rotation.z);
};
